import { useParams } from "react-router-dom";

import PartnersComponent from "components/disribution/partners";
import PartnersProd from "components/disribution/partnersProd";

import PageTab from "components/common/pageTab";
import TopImage from "components/common/topImage";
import ImgUrl from 'assets/images/business.png';

import 'assets/css/distribution.scss';

import { pageMenuTabList02 } from 'types/common';

const Partners = () => {
  const { partnersId } = useParams<{ partnersId: string }>();

  pageMenuTabList02[1].on = true;

  return (
    <div className="page_content">
      <TopImage imgUrl="https://img.chunhomall.com/images/brand_site/oemodm-hero_1920x1080.jpg.jpg" imgText="파트너사" textcolor="#FFF"></TopImage>
      <PageTab props={pageMenuTabList02}></PageTab>
      <div className="container">
        <div className="container-title">
          제품 기획과 개발, 그리고 꼼꼼한 품질 검수까지<br/>
          천호엔케어가 그 연결의 <span className="highlight">플랫폼</span>이 되겠습니다.
        </div>
      </div>
      <div className="distribution">
        <div className="container">
          <div className="distribution-title">대표 파트너사</div>
          <PartnersComponent strType="C"></PartnersComponent>

          <div className="distribution-title">업체별 대표 제품</div>
          <PartnersComponent strType="P"></PartnersComponent>

          <div className="distribution-title">특판 전용 상품</div>
          <PartnersComponent strType="S"></PartnersComponent>
        </div>
      </div>
    </div>
  );
};

export default Partners;
